<template>
  <div id="app" class = "" style="    height: 100%;">
    <v-app>
      <router-view @loadExist="getExistencia"/>
    </v-app>
    

  </div>
</template>

<script>
document.title == "Reservas Puerto Cancun"
import '../src/assets/css/uv_style.css'
import '../src/assets/css/WebFont/font-css/LineIcons.css'


let fSingleton;


export default {
  name: 'app',
  components: {

  },

  methods:{
    async getPDVDepartamentos(){
      var data =  await this.$store.getters.getFirebaseApp.database.ref("PDV/Departamentos").on("value",(snapshot)=>{
            if (snapshot.exists()){
                let arrayOrg      = Object.entries(snapshot.val());
                let cate = [];
                arrayOrg.forEach((element)=>{
                    //this.Origen =  element[0];
                    cate.push({id:element[0],...element[1]});
                });
                this.$uvHelper.log(cate);
                this.$store.commit('setPDVDepartamentos', cate);
            }

        });
    },
    async getRVACatalogo(){

      var data =  await this.$store.getters.getFirebaseApp.database.ref("RVA/Catalogo");

      if(!process.env.IS_ELECTRON){
         // data =  data.orderByChild("Categoria/Golf Addon").equalTo(true);
      }


      data.on("value",(snapshot)=>{
            if (snapshot.exists()){
                let arrayDep      = Object.entries(snapshot.val()); 
                let cat = [];

                arrayDep.forEach((element)=>{
                    cat[element[1].Codigo] = {id:element[0],...element[1]}; 
                });
                this.$uvHelper.log(cat,true);
                this.$store.commit('setRVACatalogo', cat)
                /*let idDepartment = {};
                dep.forEach((element)=>{
                  idDepartment[element.Nombre]=element.id;
                });*/
              /* this.$store.commit('setDepartamentos', dep);
                this.$store.commit('setIdDepartamentos',idDepartment);
                if(!localStorage.getItem("selectedDepartment")){
                    localStorage.setItem("selectedDepartment",this.$store.getters.getIdDepartamentos.Golf);
                }*/
            }

        });

    },
    async getDepartamentos(){

      var data =  await this.$store.getters.getFirebaseApp.database.ref("RVA/Departamentos").on("value",(snapshot)=>{
            if (snapshot.exists()){
                let arrayDep      = Object.entries(snapshot.val());
                let dep = [];
                arrayDep.forEach((element)=>{
                    dep.push({id:element[0],...element[1]});
                });
                let idDepartment = {};
                dep.forEach((element)=>{
                  idDepartment[element.Nombre.replace(' ', '_')]=element.id;
                });
                this.$store.commit('setDepartamentos', dep);
                this.$store.commit('setIdDepartamentos',idDepartment);
                if(!localStorage.getItem("selectedDepartment")){
                    localStorage.setItem("selectedDepartment",this.$store.getters.getIdDepartamentos.Golf);
                }

                localStorage.setItem("GolfDepartment",this.$store.getters.getIdDepartamentos.Golf);
                localStorage.setItem("TopDepartment",this.$store.getters.getIdDepartamentos.Top_Tracer)
            }

        });

    },
    async getOrigenes(){
      var data =  await this.$store.getters.getFirebaseApp.database.ref("PDV/Inventario/Origenes").on("value",(snapshot)=>{
            if (snapshot.exists()){
                let arrayOrg      = Object.entries(snapshot.val()); 
                let origenes = [];
                arrayOrg.forEach((element)=>{
                    //this.Origen =  element[0];
                    origenes.push({id:element[0],Nombre:element[1]['Nombre'],Departamentos:element[1]['Departamentos']}); 
                });

                this.$store.commit('setCentrosConsumo', origenes);
            }

        });
    },
    async getExistencia(){
      let config = this.$uvHelper.readConfig();
      const dataCaja          = await this.$store.getters.getFirebaseApp.database.ref("PDV/Cajas/"+config.caja_id+"").once("value");
      let result              = dataCaja.val();
      if(!result){
        return false;
      }

      this.$store.dispatch('listenerInventarios',result);


    },
    async getExistenciaWeb(){
      var dataOrigen =  await this.$store.getters.getFirebaseApp.database.ref("PDV/Inventario/Origenes").once("value");
      if(!dataOrigen.exists()){
        return false;
      }
      let arrayOrg      = Object.entries(dataOrigen.val()); 
      let origenesNames = [];
      arrayOrg.forEach(function(element){
        origenesNames.push({id:element[0],Nombre:element[1]['Nombre'],Departamentos:element[1]['Departamentos']}); 
      });
      var data =  await this.$store.getters.getFirebaseApp.firestore.collection("PDV_Inventario")
        .onSnapshot((querySnapshot) => {
            let origenes = [];
            querySnapshot.forEach((doc) =>{
              let itemIndex = this.$_.findIndex(origenesNames,{ 'id': doc.data().Origen});
              origenes.push({id:doc.ref.id,nombreOrigen:origenesNames[itemIndex].Nombre,...doc.data()});
            });
             //this.$uvHelper.log(origenes);
             //this.$uvHelper.log('detectando cambio, aplicando listener');
            this.$store.commit('setOrigenes', origenes);
        });

    },
    async getMayoristas(){


       await this.$store.getters.getFirebaseApp.database.ref("RVA/Mayoristas/Coleccion").on("value",(snapshot)=>{
            let mayoristas = [];
            let arrayHoteles =  Object.entries(snapshot.val());
            arrayHoteles.forEach((element)=>{
            mayoristas.push({id:element[0],...element[1]}); 

            });
            this.$store.commit('setMayoristas', mayoristas);

        });
    
     
      
    },
    async getProducts(){
       
        /*const startDate = this.input_date.format('YYYY-MM-DD');
        const end = startDate.replace(
            /.$/, c => String.fromCharCode(c.charCodeAt(0) + 1),
        );*/
       
        var data =  await this.$store.getters.getFirebaseApp.firestore.collection("PDV_Productos")
        .onSnapshot((querySnapshot) => {
            let prod = [];
           
            querySnapshot.forEach((doc) =>{
                prod.push({id:doc.ref.id,...doc.data()});
            });
             
             this.$store.commit('setProductos', prod);
           
        
        });
        //this.$uvHelper.log(data);
        

        /*.where('Fecha', '>=', startDate)
        .where('Fecha', '<', end);
        if(this.$route.params.user.tokenResult.claims.Type == "Hotel"){
            data = data.where("Accesos", "array-contains", this.$route.params.user.tokenResult.claims.Code)
            data = data.where("TipoCreador","==","Hotel")
        }*/
        //data = await data.where("Tenant","==",this.$store.getters.getFirebaseApp.tenant).get();
        //this.$uvHelper.log(data.docs.map(doc=>{return {id:doc.ref.id,...doc.data()}}));
        //this.products = data.docs.map(doc=>{return {id:doc.ref.id,...doc.data()}});

    },
  },
  computed:{
   
  },
  beforeMount: async function() {
    await this.$store.dispatch('FirebaseApp/initFirebaseApp', null, { root: true })
    await this.getDepartamentos();
    this.getRVACatalogo();
    const user = await await this.$store.getters.getFirebaseApp.auth.currentUser
    if(user){
      await this.$store.dispatch('listenerTiposCambio');
      this.$store.dispatch('listenerProducts'); 
      this.$store.dispatch('listenerClientes');
     
    }
    //this.getProducts();
    this.getMayoristas();
    this.getOrigenes();
    this.getPDVDepartamentos();
    if(process.env.IS_ELECTRON){
      
       if(user){
          this.$store.dispatch('listenerInventarios',this);
        }
      
    }else{
      if(user){
      this.$store.dispatch('listenerInventariosWeb',this);
      }
    }
    
  }
}
</script>

<style>

  

  .pc-bg{
    background: #404c95 !important;
  }

  .pc-tc{
    color: #404c95 !important;
  }

  .marginlefting {
   margin-left: 60px !important;
 }
 
 .displaynone {
   display: none !important;
 }
 
 .displayblock {
   display: block !important;
 }
 
 .sidebar .item i {
   font-size: 24px;
   margin-top: -5px !important;
 }
 
 .logo {
   height: 148px !important;
   padding: 10px !important;
 }
 
 .logo img {
   width: 70% !important;
   height: 100px !important;
 }
 
 .title.item {
   padding: .92857143em 1.14285714em !important;
 }
 
 .dropdown .menu .header {
   padding-top: 3.9px!important;
   padding-bottom: 3.9px!important;
 }
 
    .Dashboard__sidebar {
      width: 240px !important;
      height: 100%;
      max-height: 100%;
      position: absolute;
      top:48px;
      left: 0;
      margin: 0 !important;
      padding-top: 1em;
      -webkit-transform: translateX(-250px);
      transform: translateX(-250px);
      -webkit-transform-style: preserve-3d;
      transform-style: preserve-3d;
      will-change: transform;
      transition-duration: .2s;
      transition-timing-function: cubic-bezier(.4, 0, .2, 1);
      transition-property: transform;
      transition-property: transform, -webkit-transform;
      z-index: 5;
    }

    .Dashboard__sidebar.visible {
      -webkit-transform: translateX(0);
      transform: translateX(0);
    }

    .Dashboard__content {
      padding:10px;
      /*margin-left: 260px !important;*/
      min-height: calc(100vh) - 48px;
      /*background-color: #EFEFEF;*/
    }

    .Dashboard__content > .content {
      padding: 1.5em;
    }

    #sidebarToggle {
      display: block;
    }

    .text.center {
      text-align: center;
    }

    .inverted.text {
      color:#FFF !important;
    }

    .inverted.grey.text {
      color:#AAA !important;
    }

    .Dashboard__content > .ui.vertical.segment {
      padding:0;
    }

    .ui.inverted.light.grey.segment {
      background-color: lightgray !important;
      color: #000 !important;
    }

    @media screen and (min-width: 1025px) {
      .Dashboard__sidebar {
        -webkit-transform: translateX(0);
        transform: translateX(0);
      }
      #sidebarToggle {
        display: none;
      }
    }
    @media screen and (max-width: 1024px) {
      .Dashboard__content {
          margin-left: 0 !important;
      }
    }
    @media only screen and (device-width: 768px) {
      /* For general iPad layouts */
      .toc{
        display:none;
      }

      .menubtn{
        display: flex !important;
      }
      .article{
        margin-left: 0px !important;
      }
      .float-menu{
        position: initial !important;
      }
    }

    @media only screen and (max-width: 700px) {
      .ui.fixed.menu {
        /*display: none !important;*/
      }

      .toc{
        display:none;
      }
      .float-menu{
        position: initial !important;
      }

      .menubtn{
        display: flex !important;
      }
      .article{
        margin-left: 0px !important;
      }

      .secondary.pointing.menu .item,
      .secondary.pointing.menu .menu {
        display: none;
      }

      .secondary.pointing.menu .toc.item {
        display: block;
      }

      .masthead.segment {
        min-height: 350px;
      }

      .masthead h1.ui.header {
        font-size: 2em;
        margin-top: 1.5em;
      }

      .masthead h2 {
        margin-top: 0.5em;
        font-size: 1.5em;
      }
    }

    body{
      background: #fff;
      font-family: "Poppins", sans-serif !important;

    }
</style>
